import { render, staticRenderFns } from "./Automacao.vue?vue&type=template&id=6d37e8be&scoped=true&"
import script from "./Automacao.vue?vue&type=script&lang=js&"
export * from "./Automacao.vue?vue&type=script&lang=js&"
import style0 from "./Automacao.vue?vue&type=style&index=0&id=6d37e8be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d37e8be",
  null
  
)

export default component.exports